import React from 'react'
import styled from 'styled-components'
import { SwapStyle } from '../Themes'

const ValidationButton = styled.button<{
  isReady: boolean
  isSmall?: boolean
  isCompact?: boolean
}>`
  color: ${({ theme, isReady }) =>
    isReady
      ? theme.validationButtonTextColor
      : theme.validationButtonTextNotReadyColor};
  background-color: ${({ theme, isReady }) =>
    isReady
      ? theme.validationButtonBackgroundColor
      : theme.validationButtonBackgroundNotReadyColor};

  border: none;
  /*
  border: 1px solid
    ${({ theme, isReady }) =>
    isReady
      ? theme.validationButtonBackgroundColor
      : theme.validationButtonBackgroundNotReadyColor};
  */

  border-radius: 10rem;
  cursor: ${({ isReady }) => (isReady ? 'pointer' : 'default')};
  font-size: ${({ isSmall }) =>
    isSmall ? SwapStyle.smallText : SwapStyle.bigText};
  justify-content: space-between;
  margin-top: ${({ isSmall }) => (isSmall ? '0' : '0.5rem')};
  overflow: hidden;
  padding: ${({ isSmall }) => (isSmall ? '13px' : '18px')};
  padding-left: 10px;
  padding-right: 10px;
  outline: none;
  width: ${({ isCompact }) => (isCompact ? 'initial' : '90%')};
  font-weight: ${({ isReady }) => (isReady ? 'bold' : 'normal')};
  text-decoration: none;
  text-align: center;
  //	width: 75%;
  align-self: center;
  box-shadow: ${({ theme, isReady }) =>
    isReady ? theme.validationButtonShadow : 'none'};
  opacity: ${({ theme, isReady }) => (isReady ? 1 : 0.3)};

  &:hover {
    transition: background-color 200ms linear;

    background-color: ${({ theme, isReady }) =>
      isReady ? theme.validationButtonBackgroundColorHover : 'inherited'};

    color: ${({ theme, isReady }) =>
      isReady ? theme.validationButtonColorHover : 'inherited'};
    /*
  border: 1px solid
    ${({ theme, isReady }) =>
      isReady
        ? theme.validationButtonBackgroundColorHover
        : theme.validationButtonBackgroundNotReadyColor};
  */
  }
  /* Tablets */
  @media (max-width: 1400px) {
    font-size: ${({ isSmall }) =>
      isSmall ? SwapStyle.smallText : SwapStyle.bigText};
  }

  /* Mobiles */
  @media (max-width: 640px) {
    font-size: ${({ isSmall }) =>
      isSmall ? SwapStyle.smallText : SwapStyle.bigText};
  }
`

export default ValidationButton
